<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ii">Don’t miss any books in this thrilling new series:</a></p><a id="page_ii">
<p class="subtitle"><em>FEARLESS</em> ™</p>
<p class="center">#1 Fearless</p>
<p class="center">#2 Sam</p>
<p class="center">#3 Run</p>
<p class="center">#4 Twisted</p>
<p class="center">#5 Kiss</p>
<p class="center">#6 Payback</p>
<p class="center">#7 Rebel</p>
<p class="center">#8 Heat</p>
<p class="center">#9 Blood</p>
<p class="centerab">Available from POCKET PULSE</p>
<div class="sideber1">
<p class="noindent">For orders other than by individual consumers, Pocket Books grants a discount on the purchase of <strong>10 or more</strong> copies of single titles for special markets or premium use. For further details, please write to the Vice-President of Special Markets, Pocket Books, 1260 Avenue of the Americas, New York, NY 10020–1586, 8th Floor.</p>
<p class="noindenta">For information on how individual consumers can place orders, please write to Mail Order Department, Simon &amp; Schuster Inc., 100 Front Street, Riverside, NJ 08075.</p>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm02.vue?c060579e